import React, { Component, useState, useEffect } from "react";
import { Route, Switch, withRouter} from "react-router-dom";
import { getStationName } from "../util/CommonUtils";
import { publishCountToCSM } from "../util/CommonUtils";
import AgeingView from "./ageing/AgeingView";
import PackageSearchView from "./packageList/PackageSearchView";
import SensitivePackageSearchView from "./packageList/SensitivePackageSearchView";
import RTSView from "./rts/RTSView.js";
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import { DetailPage } from "./detailPages/DetailPage";
import { withScrubInterface } from "./scrub/ScrubInterface";
import { ScrubListView } from "./scrub/ScrubListView";
import PriorityPackages from "./priority/PriorityPackages";
import DwellTabs from "./DwellTabs";
import QCDashboard from "./qcDashboard/QCDashboard";
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import { getDarkModeStatus, setDarkModeStateListener} from "../handler/ParentDataHandler";

function publishRoutePath(location) {
  const metricProcessName = "SCC_PACKAGE_SUMMARY_" + getStationName();
  const metricName = location.pathname;
  publishCountToCSM({
    processName: metricProcessName,
    metricName: metricName,
  });
}
const AppComponent = () => {
  const [currentDarkMode, setCurrentDarkMode] = useState("light");

  useEffect(() => {
    setDarkModeStateListener(setCurrentDarkMode);
    getDarkModeStatus();
  }, []);

  return (
    <Theme
      tokens={currentDarkMode === "dark" ? blueDarkTokens : blueLightTokens}
    >
      <Switch>
        <Route exact path="/ageingBoard/:context?" component={AgeingView} />
        <Route
          exact
          path="/scrubBoard/:view"
          component={withScrubInterface(ScrubListView)}
        />
        <Route exact path="/rtsBoard/:context?" component={RTSView} />
        <Route exact path="/qcDashboard" component={QCDashboard} />

        <Route
          exact
          path="/dwellingBoard/sd/:context?/packageSearch/:context?"
          component={PackageSearchView}
        />

        <Route
          exact
          path="/dwellingBoard/sd/:context?/packageSearch/:context/:entityId/:detailParam?"
          component={DetailPage}
        />

        <Route
          exact
          path="/dwellingBoard/:context?/packageSearch/:context?"
          component={PackageSearchView}
        />

        <Route
            exact
            path="/dwellingBoard/:context?/sensitivePackageSearch/:context?"
            component={SensitivePackageSearchView}
        />

        <Route
          exact
          path="/dwellingBoard/:context?/packageSearch/:context/:entityId/:detailParam?"
          component={DetailPage}
        />

        <Route path="/dwellingBoard" component={DwellTabs} />

        <Route
          exact
          path="/ageingBoard/:context?/packageSearch/:context?" 
          component={PackageSearchView}
        />

        <Route
          exact
          path="/rtsBoard/:context?/packageSearch/:context?"
          component={PackageSearchView}
        />

        <Route
          exact
          path="/ageingBoard/:context?/packageSearch/:context/:entityId/:detailParam?"
          component={DetailPage}
        />
        <Route
          exact
          path="/rtsBoard/:context?/packageSearch/:context/:entityId/:detailParam?"
          component={DetailPage}
        />

        <Route
          exact
          path="/detailPage/:entityId/:detailParam?"
          component={DetailPage}
        />
        <Route exact path="/detailPage" component={DetailPage} />
        <Route exact path="/priorityPage" component={PriorityPackages} />
      </Switch>
    </Theme>
  );
};

class App extends Component {
  componentWillMount() {
    publishRoutePath(this.props.location);
    this.onRouteSwitch = this.props.history.listen(() => {
      publishRoutePath(this.props.location);
    });
  }
  componentWillUnmount() {
    this.onRouteSwitch();
  }

  render() {
    return <AppComponent />;
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/app.js